import React, { useMemo } from 'react';
import { Box } from '@mui/system';
import { Loading } from 'components';
import { useEmissionsAllocation } from 'hooks';
import { SETUPS_OVERVIEW_COLUMNS } from './consts';
import { ISetupsOverviewProps } from '../../types';
import { AddNewAllocationSetupButton, AllocationSetupsTable } from './components';

export const SetupsOverview = ({ onAddNewAllocationSetup, onViewDetails }: ISetupsOverviewProps) => {
    const { data: emissions, isFetching } = useEmissionsAllocation();
    const columns = useMemo(() => SETUPS_OVERVIEW_COLUMNS, []);

    if (isFetching) return <Loading />;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }} aria-label="Emissions Allocation Setups Overview">
            <AddNewAllocationSetupButton onClick={onAddNewAllocationSetup} />
            {emissions && <AllocationSetupsTable data={emissions} columns={columns} onViewDetails={onViewDetails} />}
        </Box>
    );
};